import httpClient from '../../../shared/services/httpClient';

const API_ENDPOINT = '/visits';

export const visitsApi = {
  // Get all visits with optional filters
  getVisits: async (filters = {}) => {
    const params = new URLSearchParams(filters).toString();
    return httpClient.get(`${API_ENDPOINT}?${params}`);
  },

  // Get today's visits
  getTodaysVisits: async () => {
    const today = new Date().toISOString().split('T')[0];
    return httpClient.get(`${API_ENDPOINT}?date=${today}`);
  },

  // Get a single visit by ID
  getVisitById: async (id) => {
    return httpClient.get(`${API_ENDPOINT}/${id}`);
  },

  // Create a new visit
  createVisit: async (visitData) => {
    return httpClient.post(API_ENDPOINT, visitData);
  },

  // Update visit details
  updateVisit: async (id, visitData) => {
    return httpClient.put(`${API_ENDPOINT}/${id}`, visitData);
  },

  // Complete a visit (add vitals and mark as completed)
  completeVisit: async (id, vitalsData) => {
    return httpClient.post(`${API_ENDPOINT}/${id}/complete`, vitalsData);
  },

  // Cancel a visit
  cancelVisit: async (id, reason) => {
    return httpClient.post(`${API_ENDPOINT}/${id}/cancel`, { reason });
  },

  // Search patients for visit registration
  searchPatients: async (query) => {
    return httpClient.get(`/patients/search?q=${query}`);
  },
};